import loadable from '@loadable/component';
import classNames from 'classnames';

import { type Image as ImageType, type ProductSearchImageItem } from '../../../shared/types';
import { ImageGalleryFallback } from './ImageGalleryFallback';
import styles from './ImageGalleryWithFallback.module.scss';

const LoadableImageGallery = loadable(async () => import('./ImageGallery'), {
    fallback: <ImageGalleryFallback />,
});

type ImageGalleryWithFallbackProps = {
    readonly title: string;
    readonly images: ImageType[] | ProductSearchImageItem[];
};

const ImageGalleryWithFallback = ({ images, title }: ImageGalleryWithFallbackProps) => (
    <div className="position-relative">
        <ImageGalleryFallback />
        <div className={classNames('position-absolute top-0 w-100 h-100', styles.wrapper)}>
            <LoadableImageGallery title={title} images={images} />
        </div>
    </div>
);

export { ImageGalleryWithFallback };
